
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Cayenne dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Cayenne certifiée Google Partner, accompagne les entreprises cayennaises pour accroître leur visibilité en ligne et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Cayenne dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Cayenne certifiée Google Partner, accompagne les entreprises cayennaises pour accroître leur visibilité en ligne et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
